import { atom } from 'recoil';
import { IBillingData } from '../../../types';

export const billingListState = atom<IBillingData[]>({
  key: 'billingListState',
  default: []
});
